/**
 * アプリの画面読み込み準備完了を親windowに伝える責務を担う
 */
import { useLayoutEffect } from 'react';

export const useEmitPrepared = () => {
  useLayoutEffect(() => {
    window.parent.postMessage({action: 'prepared'}, '*');
  }, []);
};
